import { render, staticRenderFns } from "./SlideRightTransition.vue?vue&type=template&id=2d811ef0&lang=pug"
import script from "./SlideRightTransition.vue?vue&type=script&lang=ts"
export * from "./SlideRightTransition.vue?vue&type=script&lang=ts"
import style0 from "./SlideRightTransition.vue?vue&type=style&index=0&id=2d811ef0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports